import * as React from 'react';
import { useState, useEffect } from 'react';
import Grid from "@mui/material/Grid";
import { Button, Divider, MenuItem, Typography } from '@mui/material';
import { CreateIssueViewModel } from '../ViewModels/CreateIssueViewModel';
import { useLocation } from 'react-router-dom';
import { ValidatorForm, SelectValidator, TextValidator } from 'react-material-ui-form-validator';
import { AlertContext } from '../Contexts/AlertContext';
import ResQComplaintCategoryViewModel from '../ViewModels/ResQComplaintsCategoryViewModel';

export default function IssueContainer() {
    const { show } = React.useContext(AlertContext);
    const urlQuery = new URLSearchParams(useLocation().search)
    const isQA = urlQuery.get("isQA");
    const [complaintsViewModel, setComplaintsViewModel] = useState<CreateIssueViewModel>(new CreateIssueViewModel(urlQuery.get("callRef"), urlQuery.get("customerId"), urlQuery.get("clientName")));
    const [types, setTypes] = useState<string[]>([]);
    const [categories, setCategories] = useState<ResQComplaintCategoryViewModel[]>([]);
    const [origins, setOrigins] = useState<string[]>([]);
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [issueExists, setIssueExists] = useState<boolean>(false);
    const [gdprResponse, setGdprResponse] = useState<string>("");

    useEffect(() => {
        setTypes(["Expression of Dissatisfaction",
            "Complaint",
            "GDPR"])
        if (isQA === "true") {
            fetch(`api/NewIssue/GetOriginDropdown`)
                .then(response => response.json()).then(data => {
                    setOrigins(data);
                });
        }
    }, []);

    useEffect(() => {
        if (complaintsViewModel.issueType != undefined) {
            setComplaintsViewModel({
                ...complaintsViewModel,
                issueCategory: ""
            })
            if (complaintsViewModel.issueType != undefined) {
                const typeRefName = typeRefNameConversion(complaintsViewModel.issueType);
                fetch(`api/NewIssue/GetCategoryDropdown?complaintType=${typeRefName}`)
                    .then(response => response.json())
                    .then(data => {
                        setCategories(data);
                    });
            }
        }
    }, [complaintsViewModel.issueType]);

    const typeRefNameConversion = (type: string) => {
        let convertedType = "";
        switch (type) {
            case "Expression of Dissatisfaction":
                convertedType = "EOD";
                break;
            case "Client Fault":
                convertedType = "client";
                break;
            default:
                convertedType = type;
                break;
        }
        return convertedType;
    }

    const handleButtonInput = (event: any) => setComplaintsViewModel({ ...complaintsViewModel, [event.target.id]: event.target.name })
    const handleTextInput = (event: any) => setComplaintsViewModel({ ...complaintsViewModel, [event.target.id]: event.target.value })
    const handleOriginDropdownInput = (event: any) => setComplaintsViewModel({ ...complaintsViewModel, originator: event.target.value })

    const handleSubmit = () => {
        fetch(`api/NewIssue/AddIssue`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(complaintsViewModel)
        })
            .then(response => response.json())
            .then((data) => {
                if (data.success) {
                    console.log(data);
                    if (data.messages.length > 0) {
                        setGdprResponse(data.messages[0]);
                    }
                    show("success", "Issue submitted")
                }
                else {
                    if (data.messages[0] === "Issue already exists") {
                        setIssueExists(true);
                    }
                    show("error", "There was an error, issue was not submitted");
                }
            })
        setSubmitted(true);
    }

    const header = (text: string) =>
        <Grid size={12}>
            <Typography variant="h5" align="center">{text}</Typography>
        </Grid>


    const divider = () =>
        <Grid size={12} marginTop={2} marginBottom={2}>
            <Divider style={{ backgroundColor: "black" }}></Divider>
        </Grid>

    return (
        !submitted ?
            <ValidatorForm onSubmit={handleSubmit}>
                <Grid container spacing={1} padding={4}>
                    {header("Select Issue Type")}
                    {
                        types.map(type =>
                            <Grid size={4} key={type}>
                                <Button
                                    id="issueType"
                                    name={type}
                                    fullWidth
                                    variant="contained"
                                    color={complaintsViewModel.issueType === type ? "secondary" : "primary"}
                                    onClick={handleButtonInput}
                                >
                                    {type}
                                </Button>
                            </Grid>)
                    }
                    {divider()}
                    {complaintsViewModel.issueType != ""
                        ?
                        <React.Fragment>
                            {header("Select Category")}
                            {
                                categories.map(category =>
                                    <Grid size={4} key={category.actionCategory}>
                                        <Button
                                            id="issueCategory"
                                            name={category.actionCategory}
                                            fullWidth
                                            variant="contained"
                                            color={complaintsViewModel.issueCategory === category.actionCategory ? "secondary" : "primary"}
                                            onClick={handleButtonInput}
                                        >
                                            {category.actionCategory}
                                        </Button>
                                        {category.actionDescription !== null &&
                                            <Typography textAlign="center">{category.actionDescription}</Typography>
                                        }
                                    </Grid>
                                )
                            }
                            {divider()}
                            {complaintsViewModel.issueCategory != "" &&
                                <React.Fragment>
                                    <Grid size={6}>
                                        <TextValidator
                                            label="Contact Name"
                                            id="contactName"
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                            autoComplete="off"
                                            value={complaintsViewModel.contactName}
                                            onChange={handleTextInput}
                                            validators={['required', 'maxStringLength:100',]}
                                            errorMessages={['This field is required', "Max input of 100 characters"]}
                                        />

                                    </Grid>
                                    {isQA === "true" &&
                                        <Grid size={6}>
                                            <SelectValidator label="Origin of Complaint" fullWidth size="small" onChange={handleOriginDropdownInput} value={complaintsViewModel.originator}>
                                                {
                                                    origins.map(origin => <MenuItem key={origin} value={origin}>{origin}</MenuItem>)
                                                }
                                            </SelectValidator>
                                        </Grid>
                                    }
                                    <Grid size={12}>
                                        <TextValidator label="Notes" id="notes" fullWidth multiline variant="outlined" onChange={handleTextInput} />
                                    </Grid>
                                    {divider()}
                                    <Grid container justifyContent="center">
                                        <Grid size={3} padding={4}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                type="submit">
                                                Submit
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </React.Fragment>}

                        </React.Fragment>
                        :
                        <React.Fragment />
                    }
                </Grid>
            </ValidatorForm>
            :
            issueExists ?
                <Grid container padding={4}>
                    <Grid size={12}>
                        <Typography variant="h4" textAlign="center">Existing Issue</Typography>
                    </Grid>
                    <Grid size={12} marginTop={3}>
                        <Typography variant="h5" textAlign="center">A second issue can not be added to this call. Please close this window and continue with Synthesys.</Typography>
                    </Grid>
                </Grid>
                :
                <Grid container padding={4}>
                    <Grid size={12}>
                        <Typography variant="h5" textAlign="center">Issue Submitted</Typography>
                    </Grid>
                    <Grid size={12} marginTop={6}>
                        <Typography variant="h4" textAlign="center">{gdprResponse}</Typography>
                    </Grid>
                    <Grid size={12} marginTop={8}>
                        <Typography variant="h6" textAlign="center">Please close this window and continue with Synthesys.</Typography>
                    </Grid>
                </Grid >
    );
}